module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("37165"))).then(() => parcelRequire('d0iPb'));